/**
 * @generated SignedSource<<192b45b1a14eda4fa928ee17a5ac6229>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BackgroundThemeEnum = "default" | "light";
export type UpdateFirmInput = {
  additionalInvoiceText?: string | null | undefined;
  allowInvoiceAutoCharge?: boolean | null | undefined;
  backgroundTheme?: BackgroundThemeEnum | null | undefined;
  billingPlanId?: string | null | undefined;
  billingPlanRawId?: number | null | undefined;
  clientMutationId?: string | null | undefined;
  currency?: string | null | undefined;
  dayforceEndpointUrl?: string | null | undefined;
  dayforceJobBoardId?: string | null | undefined;
  dayforcePassword?: string | null | undefined;
  dayforceUsername?: string | null | undefined;
  dayforceWorkspace?: string | null | undefined;
  defaultPaymentMethodId?: string | null | undefined;
  description?: string | null | undefined;
  emailsForInvoices?: ReadonlyArray<string> | null | undefined;
  firmId?: string | null | undefined;
  greenhouseApiKey?: string | null | undefined;
  invoiceSalariesInAdvance?: boolean | null | undefined;
  invoiceSchedule?: string | null | undefined;
  logoUrl?: string | null | undefined;
  managerForNonPayrollFees?: string | null | undefined;
  mergeAccountToken?: string | null | undefined;
  minSalaryDaysToInvoice?: number | null | undefined;
  name?: string | null | undefined;
  nextAutoInvoiceDate?: string | null | undefined;
  purchaseOrderNumberForNonPayrollFees?: string | null | undefined;
  showTeamTimeOffRequests?: boolean | null | undefined;
  timezoneName?: string | null | undefined;
  unifyInvoicesInPreferredCurrency?: boolean | null | undefined;
  website?: string | null | undefined;
};
export type AlternativeBackgroundButton_UpdateFirmMutation$variables = {
  input: UpdateFirmInput;
};
export type AlternativeBackgroundButton_UpdateFirmMutation$data = {
  readonly updateFirm: {
    readonly firm: {
      readonly backgroundTheme: BackgroundThemeEnum | null | undefined;
      readonly rawId: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type AlternativeBackgroundButton_UpdateFirmMutation = {
  response: AlternativeBackgroundButton_UpdateFirmMutation$data;
  variables: AlternativeBackgroundButton_UpdateFirmMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "backgroundTheme",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AlternativeBackgroundButton_UpdateFirmMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateFirmPayload",
        "kind": "LinkedField",
        "name": "updateFirm",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Firm",
            "kind": "LinkedField",
            "name": "firm",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AlternativeBackgroundButton_UpdateFirmMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateFirmPayload",
        "kind": "LinkedField",
        "name": "updateFirm",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Firm",
            "kind": "LinkedField",
            "name": "firm",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b43cb9b195acd1ba336683af7d0f7007",
    "id": null,
    "metadata": {},
    "name": "AlternativeBackgroundButton_UpdateFirmMutation",
    "operationKind": "mutation",
    "text": "mutation AlternativeBackgroundButton_UpdateFirmMutation(\n  $input: UpdateFirmInput!\n) {\n  updateFirm(input: $input) {\n    firm {\n      rawId\n      backgroundTheme\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3bbabe5e5ae15a13633cb82e654f74cf";

export default node;
